import './ui.css';

/**
 * Standard page section. Owns vertical rhythm and background treatment so no
 * page has to invent its own spacing.
 *
 * `tone` — 'default' | 'alt' | 'sunk' | 'navy' | 'navy-deep'
 */
const Section = ({
  children,
  tone = 'default',
  tight = false,
  flushTop = false,
  flushBottom = false,
  narrow = false,
  id,
  as: Tag = 'section',
  reveal = true,
  className = '',
  'aria-labelledby': ariaLabelledBy,
  ...rest
}) => {
  const classes = [
    'section',
    tone !== 'default' ? `section--${tone}` : '',
    tight ? 'section--tight' : '',
    flushTop ? 'section--flush-top' : '',
    flushBottom ? 'section--flush-bottom' : '',
    tone === 'navy' || tone === 'navy-deep' ? 'on-navy' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Tag
      id={id}
      className={classes}
      aria-labelledby={ariaLabelledBy}
      {...(reveal ? { 'data-reveal': '' } : {})}
      {...rest}
    >
      <div className={`container${narrow ? ' container--narrow' : ''}`}>
        {children}
      </div>
    </Tag>
  );
};

export default Section;
